import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { ManualsSection } from './components/ManualsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1049314170929647';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
      }
      if (!w.__mpPixelInitialized) {
        w.fbq('init', META_PIXEL_ID);
        w.__mpPixelInitialized = META_PIXEL_ID;
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen w-full bg-ivory text-ink selection:bg-forest/15 selection:text-forest" data-id="element-0" data-mp="sudkecc4nt77">
      <main data-id="element-1" data-mp="35yq6nee9s31">
        <Hero data-id="element-2" data-mp="35oxgs1yt6tn" />
        <TestimonialsStrip data-id="element-3" data-mp="356sn718lka4" />
        <PainPoints data-id="element-4" data-mp="38kxqn1ac7l9" />
        <SolutionReveal data-id="element-5" data-mp="3uct2jhejuizf" />
        <VolumesSection data-id="element-6" data-mp="3udkos1m9b4d1" />
        <ManualsSection data-id="element-7" data-mp="3ubzvsgflbtha" />
        <BonusSection data-id="element-8" data-mp="3uevqlvw5621i" />
        <PricingSection data-id="element-9" data-mp="d4e6dvbvvgxr" />
        <ExtendedTestimonials data-id="element-10" data-mp="d4xlz5e29t8m" />
        <Guarantee data-id="element-11" data-mp="d3wdn8ofjkul" />
        <FAQ data-id="element-12" data-mp="d2bjhk6123x9" />
        <FinalCTA data-id="element-13" data-mp="85l0op2u8u85" />
      </main>
      <Footer data-id="element-14" data-mp="86meh1b8nutk" />
      <PurchaseNotifications data-id="element-15" data-mp="86w3alkjrvxo" />
    </div>;
}